import { memo } from 'react';
import { Observation } from '../types/domain';
import { observationDurationLabel } from '../utils/observations';

export const ObservationTimeline = memo(function ObservationTimeline({ observations }: { observations: Observation[] }) {
  if (!observations.length) return <p className="rounded-md border border-dashed border-white/15 p-5 text-sm text-slate-400">No monitoring observations recorded.</p>;
  return (
    <ol className="space-y-3">
      {observations.map((item) => (
        <li key={item.id} className="rounded-md border border-white/10 bg-white/[0.06] p-4">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="font-semibold text-white">{item.message}</p>
              <p className="mt-1 text-sm text-slate-400">Source: {item.source.replace(/-/g, ' ')} · Started: {new Date(item.startedAt).toLocaleTimeString()}</p>
              <p className="text-sm text-slate-400">{item.endedAt ? `Ended: ${new Date(item.endedAt).toLocaleTimeString()}` : 'Still active'} · Duration: {observationDurationLabel(item.durationMs)}</p>
            </div>
            <span className={`rounded-md px-2.5 py-1 text-xs font-bold uppercase ${item.recovered ? 'bg-emerald-500/15 text-emerald-300' : item.status === 'unresolved' ? 'bg-amber-500/15 text-amber-200' : 'bg-sky-500/15 text-sky-200'}`}>{item.status}</span>
          </div>
          {item.occurrenceCount > 1 ? <p className="mt-2 text-xs text-slate-400">Occurrence {item.occurrenceCount}</p> : null}
        </li>
      ))}
    </ol>
  );
});
